import $ from "jquery";
import axios from 'axios';
import selectize from 'selectize';

import "core-js/es/array/find-index";
import "core-js/es/object/assign";
import "core-js/es/promise";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');
axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

$.holdReady(true);

$(document).ready(()=>{
    $('[data-js-selectize]').selectize({placeholder: "Select some options"});
});

